import { validation } from '@/util/validation.js';
let buyStartTime = '';
let buyEndTime = '';
export default {
        searchShow: true,
        searchMenuSpan: 6,
        calcHeight: 120,
        align: 'right',
        emptyBtn:false,
        submitBtn:false,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        delBtn: true,
        selection: true,
        menuWidth: 200,
        column: [{
                label: '车场名称',
                type: 'tree',
                prop: 'spaceId',
                clearable: false,
                span: 8,
                disabled:true,
                // formslot:true,
                cascaderItem: ['ruleId'],
                props: {
                        label: 'title',
                        value: 'key',
                },
                rules: [{
                        required: true,
                        message: '请选择车场名称',
                        trigger: 'change',
                },],
                dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
        },
        {
                label: '车牌号',
                prop: 'carNo',
                filterable: false,
                disabled:true,
                span: 8,
                rules: [{
                        required: true,
                        message: '请选择车牌号',
                        trigger: 'change',
                },
                {
                        pattern: validation.carPlate,
                        message: '车牌号格式错误',
                        trigger: 'blur',
                },
                ],
        },
        {
                label: '通行区域',
                prop: 'regions',
                hide: true,
                multiple: true,
                leafOnly: false,
                checkStrictly: true,
                span: 8,
                type: 'tree',
                dataType: 'string',
                dicData: [],
                props: {
                  labelText: '标题',
                  label: 'title',
                  value: 'id',
                  children: 'children',
                },
                rules: [{
                        required: true,
                        message: '请选择通行区域',
                        trigger: 'change',
                },],
        },
        {
                label: '车辆分类',
                span: 8,
                hide: true,
                type: 'select',
                formslot:true,
                // dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
                props: {
                        label: 'dictValue',
                        value: 'dictKey',
                },
                rules: [{
                        required: true,
                        message: '请选择车辆分类',
                        trigger: 'change',
                },],
                dataType: 'number',
                prop: 'carClass',
        },
        {
                label: '车辆类型',
                span: 8,
                hide: true,
                type: 'select',
                formslot:true,
                // dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
                props: {
                        label: 'dictValue',
                        value: 'dictKey',
                },
                dataType: 'number',
                prop: 'carType',
                rules: [{
                        required: true,
                        message: '请选择车辆类型',
                        trigger: 'blur',
                },],
        },
        {
                label: '租赁起期',
                prop: 'buyStartTime',
                span: 8,
                width: 100,
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd 00:00:00',
                clearable:false,
                formslot:true,
                rules: [{
                        required: true,
                        message: '请输入租赁起期',
                        trigger: 'change',
                        },
                        {
                                validator: (rule, value,callback) => {
                                        buyStartTime = value;
                                        if(buyEndTime){
                                                var dateStart = Date.parse(buyEndTime);
                                                var dateEnd = Date.parse(value);
                                                if (dateStart <= dateEnd) {
                                                        callback(new Error('租赁止期必须大于租赁起期！'));
                                                } else {
                                                        callback();
                                                }
                                        }

                                },
                                trigger: 'change',
                        },
                ],
        },
        {
                label: '收费套餐',
                prop: 'ruleId',
                type: 'tree',
                formslot:true,
                // dicUrl:'/api/v4ward/car/monthChangeRule/monthChargeRuleList?spaceId={{key}}',
                dicData: [],
                props: {
                        label: 'remark',
                        value: 'id',
                },
                rules: [{
                        required: true,
                        message: '请选择收费套餐',
                        trigger: 'blur',
                },],
                span: 8,
        },
        {
                label: '续租时长',
                prop: 'cycleNum',
                span: 8,
                type: 'select',
                formslot:true,
                // dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
                props: {
                        label: 'dictValue',
                        value: 'dictKey',
                },
                dataType: 'number',
        },
        {
                label: '租赁止期',
                prop: 'buyEndTime',
                type: 'date',
                width: 100,
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd 23:59:59',
                span: 8,
                clearable:false,
                rules: [{
                        required: true,
                        message: '请输入租赁止期',
                        trigger: 'change',
                },
                {
                        validator: (rule, value, callback) => {
                                buyEndTime = value;
                                if(buyStartTime){
                                        var dateStart = Date.parse(buyStartTime);
                                        var dateEnd = Date.parse(value);
                                        if (dateStart >= dateEnd) {
                                                callback(new Error('租赁止期必须大于租赁起期！'));
                                        } else {
                                                callback();
                                        }
                                }

                        },

                        trigger: 'change',
                },
                ],
        },
        {
                label: '应收金额',
                prop: 'shouldMoney',
                precision: 2,
                width: 70,
                maxlength: 11,
                showWordLimit: true,
                mock: {
                        type: 'number',
                        max: 1,
                        min: 2,
                        precision: 2,
                },
                rules: [{
                        pattern: /^\d+(\.\d+)?$/,
                        message: '格式错误'
                },],
                minRows: 0.01,
                span: 8,
        },
        {
                label: '支付金额',
                prop: 'payMoney',
                width: 70,
                span: 8,
                precision: 2,
                maxlength: 11,
                showWordLimit: true,
                mock: {
                        type: 'number',
                        max: 1,
                        min: 2,
                        precision: 2,
                },
                minRows: 0.01,
                rules: [{
                        pattern: /^\d+(\.\d+)?$/,
                        message: '格式错误'
                },],
        },
        {
                label: '客户姓名',
                span: 8,
                prop: 'customerName',
                width: 70,
                maxlength: 10,
                disabled: true,
                showWordLimit: true,
                rules: [{
                        required: true,
                        message: '请输入客户姓名',
                        trigger: 'blur',
                },],
        },
        {
                label: '客户手机',
                prop: 'customerPhone',
                width: 100,
                span: 8,
                disabled: true,
                rules: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur',
                },],
        },
        {
                label: '车位编号',
                prop: 'lotNo',
                span: 8,
                disabled: true,
                maxlength: 30,
                showWordLimit: true,
                rules: [{
                        required: false,
                        message: '请输入停车车位编号',
                        trigger: 'change',
                },],
        },
        {
                label: '状态',
                prop: 'status',
                search: true,
                width: 70,
                type: 'select',
                formslot:true,
                // dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
                props: {
                        label: 'dictValue',
                        value: 'dictKey',
                },
                dataType: 'number',
                span: 8,
        },

        {
                label: '房间',
                prop: 'areaName',
                hide: true,
                span: 16,
                disabled: true,
        },
        {
                label: '电子资料',
                prop: 'imgUrl',
                type: 'upload',
                listType: 'picture-img',
                propsHttp: {
                        res: 'data',
                        url: 'link',
                },
                action: '/api/v4ward/oss/customEndpoint/put-file',
                tip: '只能上传jpg/png格式的图片，且不超过500kb',
                span: 24,
                row: true,
        },
        {
                label: '备注',
                prop: 'remark1',
                type: 'textarea',
                hide: true,
                span: 24,
                maxlength: 200,
                showWordLimit: true,
                minRows: 2,
                rules: [{
                        required: false,
                        message: '办公车辆请输入备注说明',
                        trigger: 'change',
                },],
        },
        ],
}
